// import React, { useState } from 'react';
import React from 'react';
import PropTypes, { object } from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { Text, Heading } from '../../Elements/Elements';
import { TrendView, Quantity, Trend } from '../parts/parts';
import ChartHS from './ChartHS';
import { calcTrend, round2 } from 'utils/common';
import { useRegionalLink } from 'hooks/useRegionalLink';

import classes from './LineHS.module.scss';

const LineHS = ({ chartData, type, linkTitle }) => {
  const generateRegionalPath = useRegionalLink();
  const { t } = useTranslation(['activity']);
  // const [healthScorePeriod, setHealthScorePeriod] = useState('6M');  //switch off until april
  const healthScorePeriod = '6M';

  const check = () => {
    return (
      chartData &&
      chartData.length !== 0 &&
      chartData[0].healthScore !== 'undefined'
    );
  };

  const length = check() ? chartData.length : 0;

  let trend = 0; // trend for choisen period
  const healthScoreCurrent = check()
    ? +chartData[length - 1].healthScore.toFixed(0)
    : 0;

  const newData = [];

  const createData = (newData, arr) => {
    arr.map(item => {
      newData.push({
        date: item.month,
        HealthScores: item.healthScore
      });
      return false;
    });

    return newData;
  };
  if (check()) {
    let dataArr = [...chartData];
    if (healthScorePeriod === '1M') {
      const temp = dataArr.slice(dataArr.length - 2);
      createData(newData, temp);
    }
    if (healthScorePeriod === '3M') {
      if (dataArr.length < 3) {
        createData(newData, dataArr);
      } else {
        const temp = dataArr.slice(dataArr.length - 3);
        createData(newData, temp);
      }
    }
    if (healthScorePeriod === '6M') {
      if (dataArr.length < 6) {
        createData(newData, dataArr);
      } else {
        const temp = dataArr.slice(dataArr.length - 6);
        createData(newData, temp);
      }
    }
    if (healthScorePeriod === '1Y') {
      createData(newData, dataArr);
    }
    if (type !== 'trend') {
      trend =
        newData.length > 1
          ? round2(
              newData[newData.length - 1].HealthScores -
                newData[newData.length - 2].HealthScores
            )
          : 0;
    } else {
      trend =
        newData.length > 1
          ? newData[newData.length - 2].HealthScores !== 0
            ? calcTrend(
                newData[newData.length - 1].HealthScores,
                newData[newData.length - 2].HealthScores,
                2
              )
            : round2(
                newData[newData.length - 1].HealthScores -
                  newData[newData.length - 2].HealthScores
              ).toString()
          : ' - Not enough data to trend calculation';
    }
  }
  return (
    <section className={cn(classes.box, type === 'trend' && classes.box_trend)}>
      {type !== 'trend' ? (
        <>
          {linkTitle ? (
            <Link to={generateRegionalPath(linkTitle)}>
              <Heading>{t('activity:customers.HEALTH_SCORE')}</Heading>
            </Link>
          ) : (
            <Heading>{t('activity:customers.HEALTH_SCORE')}</Heading>
          )}
          <div className={classes.info}>
            <Text type="p" className={classes.info_wrap}>
              <Quantity how={healthScoreCurrent} />
              <TrendView trend={trend} />
            </Text>
          </div>
        </>
      ) : (
        <div className={classes.trend_wrap}>
          <div className={classes.trend}>
            <Heading>Trendline</Heading>
            {newData.length > 1 ? (
              <Trend trend={trend} />
            ) : (
              <Text size={6}>&nbsp;{trend}</Text>
            )}
          </div>
        </div>
      )}
      <div className={classes.content}>
        <div className={classes.back_green}></div>
        <div className={classes.back_lgreen}></div>
        <div className={classes.back_yellow}></div>
        <div className={classes.back_red}></div>
        <div className={classes.chart_wrap}>
          <ChartHS chartData={newData} />
        </div>
        <div className={classes.legend}>
          <Text className={classes.legend_red}>At Risk</Text>
          <Text className={classes.legend_yellow}>Need Attention</Text>
          <Text className={classes.legend_lgreen}>Healthy</Text>
          <Text className={classes.legend_green}>Champion</Text>
        </div>
      </div>
    </section>
  );
};

LineHS.propTypes = {
  chartData: PropTypes.oneOfType([PropTypes.arrayOf(object), PropTypes.bool]),
  type: PropTypes.string,
  linkTitle: PropTypes.string
};

export default LineHS;
